import React, { useState, useEffect } from 'react';
import { Download, RefreshCw, X } from 'lucide-react';

export default function UpdateNotification() {
  const [updateVersion, setUpdateVersion] = useState(null);
  const [progress, setProgress] = useState(null);
  const [downloaded, setDownloaded] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const isElectron = window.electronAPI?.isElectron;

  useEffect(() => {
    if (!isElectron) return;

    window.electronAPI.onUpdateAvailable((version) => {
      setUpdateVersion(version);
      setDismissed(false);
    });

    window.electronAPI.onUpdateProgress((percent) => {
      setProgress(percent);
    });

    window.electronAPI.onUpdateDownloaded((version) => {
      setUpdateVersion(version);
      setDownloaded(true);
      setProgress(null);
    });
  }, [isElectron]);

  if (!isElectron || !updateVersion || dismissed) return null;

  return (
    <div
      data-testid="update-notification"
      className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] bg-slate-800 border border-dp-500/30 rounded-xl px-5 py-3 shadow-2xl flex items-center gap-4"
    >
      {downloaded ? (
        <>
          <RefreshCw className="w-5 h-5 text-green-400 animate-spin-slow" />
          <span className="text-sm text-white">
            v{updateVersion} ready to install
          </span>
          <button
            data-testid="install-update-btn"
            onClick={() => window.electronAPI.installUpdate()}
            className="px-3 py-1 bg-green-600 hover:bg-green-500 text-white text-sm rounded-lg transition-colors"
          >
            Restart & Update
          </button>
        </>
      ) : progress !== null ? (
        <>
          <Download className="w-5 h-5 text-dp-300 animate-pulse" />
          <span className="text-sm text-white">
            Downloading v{updateVersion}...
          </span>
          <div className="w-32 h-2 bg-slate-700 rounded-full overflow-hidden">
            <div
              className="h-full bg-dp-500 rounded-full transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="text-xs text-slate-400">{progress}%</span>
        </>
      ) : (
        <>
          <Download className="w-5 h-5 text-dp-300" />
          <span className="text-sm text-white">
            Update v{updateVersion} available — downloading...
          </span>
        </>
      )}
      <button
        data-testid="dismiss-update-btn"
        onClick={() => setDismissed(true)}
        className="ml-2 text-slate-400 hover:text-white"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
